// 0 Developer 1 Production
const production = 1;
exports.production = production;

const porta = 3005
exports.porta = porta;

exports.url_backend = (production === 1
  ? "https://erpbi.apicesistemas.com.br"
  : "http://192.168.1.120:" + porta);

exports.tipo_usuario_admin = 1;
exports.tipo_usuario_proprietario = 2;
exports.tipo_usuario_financeiro_cr_cp = 3;
exports.tipo_usuario_vendas = 4;
exports.tipo_usuario_vendas_cr = 5;



// WEBPACK FOOTER //
// ./src/utils/constants.js